import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SubmenuModel } from '../layout/submenu/models/submenu.model';

@Component({
  selector: 'app-sites-builder',
  templateUrl: './sites-builder.component.html',
})
export class SitesbuilderComponent implements OnInit {
  public serviceSubmenuTabs: SubmenuModel;
  public showMenu: boolean;
  constructor(private router: Router) {
    // this.serviceSubmenuTabs = {
    //   serviceName: 'Sitesbuilder',
    //   tabs: [{ title: 'Client sites', path: '/sitesbuilder/public/sites' }],
    //   privateTabs: [
    //     { title: 'Minisites', path: '/sitesbuilder/private/list' },
    //     { title: 'Workflows', path: '/sitesbuilder/private/workflows' },
    //   ],
    // };
    this.serviceSubmenuTabs = {
      publicService: {
        name: 'Sites Builder',
        tabs: [{ title: 'My Sites', path: '/sitesbuilder/public/sites' }]
      },
      privateService: {
        name: 'Sites Builder',
        tabs: [
          { title: 'Minisites', path: '/sitesbuilder/private/list' },
          { title: 'Workflows', path: '/sitesbuilder/private/workflows' },
        ]
      }
    };

    this._updateMenuVisibility(this.router.url);
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this._updateMenuVisibility(event.url);
      }
    });
  }

  _updateMenuVisibility(url: string): void {
    this.showMenu = !url.includes('/editor/');
  }
}
